import { uzytkownicyService } from "../../services/uzytkownicy.service";
import {
  UzytkownikWidok,
  uzytkownicyConsts,
  Uzytkownik
} from "../types/uzytkownicy";
import { handleSessionError } from "../../services/handleSessionError";
import { RolaUzytkownika, Produkt } from "../types/organizacje";
import { uxActions } from "./ux.actions";

export const uzytkownicyActions = {
  daj,
  zapros,
  zaprosPonownie,
  przegladaj,
  usun,
  edytuj,
  clearBrowseError,
  clearEditError
};

function daj(idOrganizacji: string, idZapr: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return uzytkownicyService.daj(idOrganizacji, idZapr).then(
      (dto: Uzytkownik) => {
        dispatch(success);
        return dto;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_DAJ_REQUEST };
  }
  function success() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_DAJ_SUCCESS };
  }
  function setError(error: string) {
    return {
      type: uzytkownicyConsts.UZYTKOWNICY_DAJ_FAILURE,
      error: error
    };
  }
}

function zapros(
  idOrganizacji: string,
  email: string,
  rola: RolaUzytkownika,
  produkty: Produkt[],
  wiadomosc: string
) {
  return (dispatch: Function) => {
    dispatch(request());
    return uzytkownicyService
      .zapros(idOrganizacji, email, rola, produkty, wiadomosc)
      .then(
        () => {
          dispatch(success);
          dispatch(uxActions.showToaster("Wysłano zaproszenie!", "success"));
          return true;
        },
        (error) => {
          handleSessionError(dispatch, error, setError(error));
        }
      );
  };

  function request() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_ZAPROS_REQUEST };
  }
  function success() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_ZAPROS_SUCCESS };
  }
  function setError(error: string) {
    return {
      type: uzytkownicyConsts.UZYTKOWNICY_ZAPROS_FAILURE,
      error: error
    };
  }
}

function zaprosPonownie(idOrganizacji: string, idZapr: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return uzytkownicyService.zaprosPonownie(idOrganizacji, idZapr).then(
      () => {
        dispatch(success);
        dispatch(uxActions.showToaster("Wysłano zaproszenie!", "success"));
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_ZAPROS_PONOWNIE_REQUEST };
  }
  function success() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_ZAPROS_PONOWNIE_SUCCESS };
  }
  function setError(error: string) {
    return {
      type: uzytkownicyConsts.UZYTKOWNICY_ZAPROS_PONOWNIE_FAILURE,
      error: error
    };
  }
}

function przegladaj(idOrganizacji: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return uzytkownicyService.przegladaj(idOrganizacji).then(
      (res: UzytkownikWidok[]) => {
        dispatch(success(res));
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_PRZEGLADAJ_REQUEST };
  }
  function success(lista: UzytkownikWidok[]) {
    return { type: uzytkownicyConsts.UZYTKOWNICY_PRZEGLADAJ_SUCCESS, lista };
  }
  function setError(error: string) {
    return {
      type: uzytkownicyConsts.UZYTKOWNICY_PRZEGLADAJ_FAILURE,
      error: error
    };
  }
}

function usun(idOrganizacji: string, idZapr: string) {
  return (dispatch: Function) => {
    dispatch(request());
    return uzytkownicyService.usun(idOrganizacji, idZapr).then(
      () => {
        dispatch(success);
        return true;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_USUN_REQUEST };
  }
  function success() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_USUN_SUCCESS };
  }
  function setError(error: string) {
    return {
      type: uzytkownicyConsts.UZYTKOWNICY_USUN_FAILURE,
      error: error
    };
  }
}

function edytuj(
  idOrganizacji: string,
  idZapr: string,
  rola: RolaUzytkownika,
  produkty: Produkt[]
) {
  return (dispatch: Function) => {
    dispatch(request());
    return uzytkownicyService.edytuj(idOrganizacji, idZapr, rola, produkty).then(
      () => {
        dispatch(success);
        return true;
      },
      (error) => {
        handleSessionError(dispatch, error, setError(error));
      }
    );
  };

  function request() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_EDYTUJ_REQUEST };
  }
  function success() {
    return { type: uzytkownicyConsts.UZYTKOWNICY_EDYTUJ_SUCCESS };
  }
  function setError(error: string) {
    return {
      type: uzytkownicyConsts.UZYTKOWNICY_EDYTUJ_FAILURE,
      error: error
    };
  }
}

function clearBrowseError() {
  return { type: uzytkownicyConsts.CLEAR_BROWSE_ERROR };
}

function clearEditError() {
  return { type: uzytkownicyConsts.CLEAR_EDIT_ERROR };
}
